import React from 'react';
import noDataFound from '../../../assets/images/icons/no-data-found.png';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns'
import { Alert, Badge } from 'react-bootstrap';

function Datatable({ columns, data }) {

  const navigate = useNavigate();

  return (
    <div className='receipt-datatable h-auto border rounded'>
      <table className='table mb-0'>
        <thead className='table-head sticky-top'>
          <tr>
            {
              columns && columns.map((th_item, index) => {
                return (
                  <th key={index} className={index === 0 || index === 1 ? 'text-start bg-table-head px-4' : index === columns.length - 1 ? 'text-end bg-table-head px-4' : 'text-center bg-table-head px-4'}>{th_item}</th>
                )
              })
            }
          </tr>
        </thead>
        {
          data && data.length > 0 ?
            <tbody>
              {
                data && data.map((item, index) => {
                  return (
                    <tr key={index} className='border-top'>
                      <td className='align-middle px-4'>{new Date(item.date.seconds * 1000).toLocaleDateString("es-CL")}</td>
                      <td
                        className="align-middle px-4 cursor-pointer text-start text-primary"
                        onClick={() => navigate(`${item.id}`, { state: { id: item.id } })}
                      >
                        {item.category && item.category.name}
                      </td>
                      <td className="align-middle px-4 text-center w-25">{item.category && item.subCategory.name}</td>
                      <td className="align-middle px-4 text-center">{item.paymentMode}</td>
                      <td className="align-middle px-4 text-end">{parseFloat(parseFloat(item.amount).toFixed(2)).toLocaleString("en-IN")}</td>
                      <td className="align-middle px-4 text-end">
                        <div className='d-flex align-items-center justify-content-end'>
                          <Badge
                            bg={item.status === 'Paid' ? 'success' : 'danger'}
                            className='fw-normal small text-uppercase px-2 py-1 mb-0'
                          >
                            {item.status}
                          </Badge>
                        </div>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
            :
            <tbody>
              <tr>
                <td colSpan={6}>
                  <div className='no-data-found'>
                    <div className='text-center'>
                      <img src={noDataFound} alt="no-data-found" className='img-fluid' />
                      <p className='mt-3'>No-Data Found</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
        }
      </table>
    </div>
  );
}

export default Datatable;